module.exports = __webpack_public_path__ + "static/media/sock-jasa3.b9e10247.png";